import "./AboutUs.module.css";
import Header from "@/reusable_sections/Header";
import OurStoryIntroduction from "./sections/OurStoryIntroduction";
import TheTransparencyReport from "./sections/TheTransparencyReport";
import SmartHomeTipsListing from "./sections/SmartHomeTipsListing";
import Footer from "@/reusable_sections/Footer";
export default function AboutUsPage() {
  return <div>
      <Header />
      <OurStoryIntroduction />
      <TheTransparencyReport />
      <SmartHomeTipsListing />
      <Footer />
    </div>;
}